var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0"},[_c('v-card',{staticClass:"pa-0",staticStyle:{"height":"calc(100vh - 112px)"}},[_c('v-card-text',{staticClass:"text-center subtitle-1"},[_vm._t("splash-content",function(){return [_vm._v(" "+_vm._s(_vm.content)+" ")]})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }